import { render } from "./BaseDivider.vue?vue&type=template&id=b120f28c&scoped=true"
const script = {}

import "./BaseDivider.vue?vue&type=style&index=0&id=b120f28c&scoped=true&lang=css"

import exportComponent from "E:\\TestProject Temurako\\e-commerce-app-master\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b120f28c"]])

export default __exports__